import { toast } from 'react-toastify';

const copyToClipBoard = (str: string) => {
  navigator.clipboard.writeText(`${str}`);
  toast.success('Copiado!');
};

export { copyToClipBoard };
